import React, { FC } from 'react';
import { DocumentStatus, PilotDoc } from '../../../../types';
import DocumentCardLayout from './DocumentCardLayout/DocumentCardLayout';
import { getThumbnail } from './utils/get-thumbnail';
import { useAppStore } from '../../../../store/appStore';
import { trackAction } from '../../../../libs/analytics/ActionTracking';
import EditDocPopup from '../EditDocPopup/EditDocPopup';
import downloadAll from './utils/download-all';
import ViewDocPopup from '../ViewDocPopup';

type DocCardProps = {
  document: PilotDoc;
  isNeedAttention?: boolean;
};

export const DocCard: FC<DocCardProps> = ({ document, isNeedAttention }) => {
  const showWindow = useAppStore((state) => state.showWindow);

  const isFixNeeded = document.status === DocumentStatus.FIX_REQUESTED;
  const attachments = document.attachments;
  const hasAttachment = Boolean(attachments?.[0]);
  const hasThumbnails = attachments?.some((a) => a.thumbnails?.large);

  function handleUploadButtonClick() {
    trackAction(`Upload new ${document.type} click`, null);
    showWindow(<EditDocPopup docType={document.type} />);
  }

  function handleEditButtonClick() {
    trackAction(`Edit ${document.type} click`, null);
    showWindow(<EditDocPopup docType={document.type} document={document} />);
  }

  function handleShowDocumentAttachments() {
    trackAction(`Show all document attachments click`, null);

    if (attachments) {
      showWindow(<ViewDocPopup docType={document.type} attachments={attachments} />);
    }
  }

  function handleDownloadAllClick() {
    trackAction('Download all document files button click', null);

    downloadAll(attachments);
  }

  return (
    <DocumentCardLayout
      docType={document.type}
      isFixNeeded={isFixNeeded}
      warningDate={isNeedAttention ? document.endDate : undefined}
      startDate={document.startDate}
      endDate={document.endDate}
      thumbnail={getThumbnail(document)}
      button={
        isNeedAttention
          ? isFixNeeded
            ? { title: 'Edit Document', onClick: handleEditButtonClick }
            : { title: 'Upload Document', onClick: handleUploadButtonClick }
          : undefined
      }
      onCardClick={hasThumbnails ? handleShowDocumentAttachments : undefined}
      onDownloadAllClick={hasAttachment ? handleDownloadAllClick : undefined}
    />
  );
};
